// AllMeals.jsx - Updated with sorting functionality
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { getAllMeals } from '../redux/actions/meals';
import { Loader, MealCategoryCard, MealsCard } from '../components/utils';


import { getAllCategorys } from '../redux/actions/category';

import { Section, Fotter, Header } from "../components/layout";
import { MealsCategoriesImage } from '../assets';
import { motion } from 'framer-motion';

import { media } from '../server';

import { FiChevronRight, FiGrid, FiList } from 'react-icons/fi';
import { BiRestaurant } from 'react-icons/bi';
import { useStateContext } from '../context/ContextProvider';

function AllMeals() {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { currentDir } = useStateContext()
  const { isLoading, AllCategorys } = useSelector((state) => state.Categorys);

  useEffect(() => {
    // عرض جميع الفئات بدون pagination
    dispatch(getAllCategorys(1, 100));
  }, [dispatch]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 100, damping: 12 },
    },
  };



  return (
    <>
      <Header active={4} DropActive={1} />
      
      {/* Hero Section with Parallax Effect */}
      <motion.div 
        className="relative w-full overflow-hidden h-[500px] lg:h-[650px]"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      >
        <img 
          src={MealsCategoriesImage} 
          className="w-full h-full object-cover" 
          alt={currentDir === "ltr" }
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
        
        <motion.div 
          className="absolute bottom-0 left-0 right-0 p-6 md:p-12 lg:p-20"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8, ease: 'easeOut' }}
        >
          <div className="container mx-auto">
            <motion.div 
              className="inline-flex items-center gap-2 bg-color-1/20 backdrop-blur-md rounded-full px-4 py-2 mb-4"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.5 }}
            >
              <BiRestaurant className="text-color-1" />
              <span className="text-color-1 text-sm uppercase tracking-wider">{t('signature dishes')}</span>
            </motion.div>
            
            <h1 className="h1 text-white mb-4 md:mb-6 max-w-3xl">
            {t("Meal Categories")}
            </h1>
            <p className="body-1 text-tcolor-2 max-w-2xl">
            {t("Explore our diverse selection of authentic Yemeni dishes, each category crafted with traditional recipes and the finest ingredients.")}
            </p>
          </div>
        </motion.div>
      </motion.div>

      {isLoading ? (
        <div className="min-h-[60vh] flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <Section>
          <div className="py-12 md:py-16">
            {/* Categories Grid - عرض جميع الفئات بدون Pagination */}
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8 sm:grid-cols-1">
              {AllCategorys?.map((category, index) => (
                <MealCategoryCard key={category._id || index} category={category} index={index} />
              ))}
            </div>

            {/* Results Count */}
            {AllCategorys?.length > 0 && (
              <p className="text-center text-gray-500 dark:text-gray-400 mt-12 text-sm font-kufi">
                {t("Showing")} {AllCategorys.length} {t("categories")}
              </p>
            )}
          </div>
        </Section>
      )}
      <Fotter />
    </>
  );
}

export default AllMeals;